export const ROLE_LABELS = {
  1: "Admin",
  2: "Company",
  3: "Employee",
  4: "Agent",
  5: "Retailer",
  6: "User",
  7: "Customer",
};
